import { render } from "./MobileWarning.vue?vue&type=template&id=07ba21f0"
import script from "./MobileWarning.vue?vue&type=script&lang=ts"
export * from "./MobileWarning.vue?vue&type=script&lang=ts"
script.render = render

export default script